const FormLabel = ({ children, ...props }) => {
  return <label {...props}>{children}</label>;
};
export default FormLabel;
